// Misc:
export const ROUTE_ROOT = 'ROUTE_ROOT'

export const ROUTE_ERROR = 'ROUTE_ERROR'
export const ROUTE_FORBIDDEN = 'ROUTE_FORBIDDEN'
export const ROUTE_NOT_FOUND = 'ROUTE_NOT_FOUND'
export const ROUTE_UNAUTHORIZED = 'ROUTE_UNAUTHORIZED'

// Users:
export const ROUTE_USERS = 'ROUTE_USERS'
export const ROUTE_USERS_MY_USERS = 'ROUTE_USERS_MY_USERS'
export const ROUTE_USER_APPROVALS = 'ROUTE_USER_APPROVALS'
export const ROUTE_USER_APPROVALS_ACTIVITY = 'ROUTE_USER_APPROVALS_ACTIVITY'
export const ROUTE_USER_APPROVALS_ACTIVITY_USER_TASKS =
  'ROUTE_USER_APPROVALS_ACTIVITY_USER_TASKS'
export const ROUTE_USER_CREATE = 'ROUTE_USER_CREATE'
export const ROUTE_USER_EDIT = 'ROUTE_USER_EDIT'
export const ROUTE_USER_PLAYTHROUGHS = 'ROUTE_USER_PLAYTHROUGHS'

// Groups:
export const ROUTE_GROUPS = 'ROUTE_GROUPS'
export const ROUTE_GROUPS_POSITIONS = 'ROUTE_GROUPS_POSITIONS'
export const ROUTE_GROUPS_POSITION_EDIT = 'ROUTE_GROUPS_POSITION_EDIT'
export const ROUTE_GROUPS_DEPARTMENTS = 'ROUTE_GROUPS_DEPARTMENTS'
export const ROUTE_GROUPS_DEPARTMENT_EDIT = 'ROUTE_GROUPS_DEPARTMENT_EDIT'
export const ROUTE_GROUPS_CUSTOM_GROUPS = 'ROUTE_GROUPS_CUSTOM_GROUPS'
export const ROUTE_GROUPS_CUSTOM_GROUP_EDIT = 'ROUTE_GROUPS_CUSTOM_GROUP_EDIT'
export const ROUTE_GROUPS_CUSTOM_GROUP_ADD_USERS =
  'ROUTE_GROUPS_CUSTOM_GROUP_ADD_USERS'
export const ROUTE_GROUPS_LEADERBOARDS = 'ROUTE_GROUPS_LEADERBOARDS'
export const ROUTE_GROUPS_LEADERBOARD_EDIT = 'ROUTE_GROUPS_LEADERBOARD_EDIT'
export const ROUTE_GROUPS_LEADERBOARD_ADD_USERS =
  'ROUTE_GROUPS_LEADERBOARD_ADD_USERS'

// Policies:
export const ROUTE_POLICIES = 'ROUTE_POLICIES'
export const ROUTE_POLICY_EDIT = 'ROUTE_POLICY_EDIT'

// Engage Creator:
export const ROUTE_PORTAL_CREATOR = 'ROUTE_PORTAL_CREATOR'
export const ROUTE_PORTAL_LAYOUT = 'ROUTE_PORTAL_LAYOUT'
export const ROUTE_PORTAL_LAYOUT_FOR_YOU = 'ROUTE_PORTAL_LAYOUT_FOR_YOU'
export const ROUTE_PORTAL_LAYOUT_JOURNEYS = 'ROUTE_PORTAL_LAYOUT_JOURNEYS'
export const ROUTE_PORTAL_LAYOUT_CATEGORIES_REORDER =
  'ROUTE_PORTAL_LAYOUT_CATEGORIES_REORDER'
export const ROUTE_PORTAL_LAYOUT_CATEGORY_CREATE =
  'ROUTE_PORTAL_LAYOUT_CATEGORY_CREATE'
export const ROUTE_PORTAL_LAYOUT_JOURNEY_CREATE =
  'ROUTE_PORTAL_LAYOUT_JOURNEY_CREATE'
export const ROUTE_PORTAL_LAYOUT_CATEGORY_EDIT =
  'ROUTE_PORTAL_LAYOUT_CATEGORY_EDIT'
export const ROUTE_PORTAL_LAYOUT_JOURNEY_EDIT =
  'ROUTE_PORTAL_LAYOUT_JOURNEY_EDIT'
export const ROUTE_PORTAL_LAYOUT_BUNDLE_EDIT = 'ROUTE_PORTAL_LAYOUT_BUNDLE_EDIT'
export const ROUTE_NEWS = 'ROUTE_NEWS'
export const ROUTE_NEWS_CREATE = 'ROUTE_NEWS_CREATE'
export const ROUTE_NEWS_EDIT = 'ROUTE_NEWS_EDIT'

// Products:
export const ROUTE_PRODUCTS = 'ROUTE_PRODUCTS'
export const ROUTE_PRODUCT_TAGS = 'ROUTE_PRODUCT_TAGS'
export const ROUTE_PRODUCT_CREATE = 'ROUTE_PRODUCT_CREATE'
export const ROUTE_PRODUCT_CREATE_SCORM = 'ROUTE_PRODUCT_CREATE_SCORM'
export const ROUTE_PRODUCT_CREATE_APP = 'ROUTE_PRODUCT_CREATE_APP'
export const ROUTE_PRODUCT_CREATE_ACTIVITY = 'ROUTE_PRODUCT_CREATE_ACTIVITY'
export const ROUTE_PRODUCT_CREATE_ATTENSI = 'ROUTE_PRODUCT_CREATE_ATTENSI'
export const ROUTE_PRODUCT_CREATE_SELECT_TYPE =
  'ROUTE_PRODUCT_CREATE_SELECT_TYPE'
export const ROUTE_PRODUCT_CHANGE_LOG = 'ROUTE_PRODUCT_CHANGE_LOG'
export const ROUTE_PRODUCT_EDIT = 'ROUTE_PRODUCT_EDIT'

// Events:
export const ROUTE_EVENTS = 'ROUTE_EVENTS'
export const ROUTE_EVENT_DATES = 'ROUTE_EVENT_DATES'
export const ROUTE_EVENT_DATE = 'ROUTE_EVENT_DATE'
export const ROUTE_EVENT_DATE_FORM = 'ROUTE_EVENT_DATE_FORM'
export const ROUTE_EDIT_EVENT = 'ROUTE_EDIT_EVENT'
export const ROUTE_EVENT_CREATE = 'ROUTE_EVENT_CREATE'

// Default routes: (change name?)
export const ROUTE_DASHBOARD = 'ROUTE_DASHBOARD'
export const ROUTE_DASHBOARD_OLD = 'ROUTE_DASHBOARD_OLD'
export const ROUTE_FAQ = 'ROUTE_FAQ'
export const ROUTE_FAQ_SUPPORT_HELP = 'ROUTE_SUPPORT_HELP'
export const ROUTE_PORTAL = 'ROUTE_PORTAL'

// Manager Wiget Route
export const ROUTE_REDIRECT_FAST = 'ROUTE_REDIRECT_FAST'

// AI Assistants:
export const ROUTE_AI_ASSISTANTS = 'ROUTE_AI_ASSISTANTS'
export const ROUTE_AI_ASSISTANT_CREATE = 'ROUTE_AI_ASSISTANT_CREATE'
export const ROUTE_AI_ASSISTANT_EDIT = 'ROUTE_AI_ASSISTANT_EDIT'
export const ROUTE_AI_ASSISTANT_PERSONALITY = 'ROUTE_AI_ASSISTANT_PERSONALITY'
export const ROUTE_AI_ASSISTANT_KNOWLEDGE = 'ROUTE_AI_ASSISTANT_KNOWLEDGE'
export const ROUTE_AI_ASSISTANT_STARTER_QUESTIONS =
  'ROUTE_AI_ASSISTANT_STARTER_QUESTIONS'
export const ROUTE_AI_ASSISTANT_DISTRIBUTION = 'ROUTE_AI_ASSISTANT_DISTRIBUTION'

// Certificates
export const ROUTE_CERTIFICATES = 'ROUTE_CERTIFICATES'
export const ROUTE_CERTIFICATES_CREATE = 'ROUTE_CERTIFICATES_CREATE'
export const ROUTE_CERTIFICATES_EDIT = 'ROUTE_CERTIFICATES_EDIT'

// Company Subsidiaries
export const ROUTE_COMPANY_SUBSIDIARIES = 'ROUTE_COMPANY_SUBSIDIARIES'
export const ROUTE_COMPANY_SUBSIDIARIES_CHILD =
  'ROUTE_COMPANY_SUBSIDIARIES_CHILD'

// Company Settings
export const ROUTE_COMPANY_SETTINGS = 'ROUTE_COMPANY_SETTINGS'
export const ROUTE_COMPANY_SETTINGS_GENERAL = 'ROUTE_COMPANY_SETTINGS_GENERAL'
export const ROUTE_COMPANY_SETTINGS_NOTIFICATIONS =
  'ROUTE_COMPANY_SETTINGS_NOTIFICATIONS'
export const ROUTE_COMPANY_SETTINGS_APPEARANCE =
  'ROUTE_COMPANY_SETTINGS_APPEARANCE'
